import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const ApiContext = createContext(null);

export const ApiProvider = ({ api, children }) => {
  if (!api) {
    throw Error('API Client must be provided');
  }
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
};

ApiProvider.propTypes = {
  api: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export const withApiContext = mapApiToProps => InnerComponent => componentProps => (
  <ApiContext.Consumer>
    {apiClient => {
      const apiProps = mapApiToProps(apiClient);
      return <InnerComponent {...apiProps} {...componentProps} />;
    }}
  </ApiContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/context/ApiContext.jsx